import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ClubServicesService } from 'src/app/shared/services/club-services.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ManageOrderderService } from 'src/app/shared/services/manage-orderder.service';

@Component({
  selector: 'app-view-details',
  templateUrl: './view-details.component.html',
  styleUrls: ['./view-details.component.scss','../../../modules/dashboard/organization-dash/organization-dash.component.scss']
})
export class ViewDetailsComponent implements OnInit {

  @Input() 
  restaurantListByUser;
  restaurantListNearBy;
  selectRestaurantData:any;
  disableRestaurantsNext: boolean = true;

  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private csObj: CommonService,
    private toast: ToastrService,
    private dialogue: MatDialog,
    private router: Router,
    private clubServ: ClubServicesService,
    private spinner: SpinnerVisibilityService,
    private manageOrdersServices: ManageOrderderService,
  ) { }

  ngOnInit(): void {
  }

  @Output() closeSelectRestaurantPopup = new EventEmitter();
  @Output() getRestaurantProducts = new EventEmitter();
  @Output() clickBack = new EventEmitter();
  @Output() selectedRestaurant = new EventEmitter();

  onclickmenu(id: any) {
    this.getRestaurantProducts.emit(id);
  }

  viewLocation(cords: any) {
    var url = `https://maps.google.com/?q=${cords[1]},${cords[0]}`;
    window.open(url, '_blank');
  }

  onclickback(){
    this.clickBack.emit();
  }

  selectRestaurantById(id: any,restaurant:any) {
    this.selectedRestaurant.emit({id,restaurant});
  }

  // getRestaurantNearByAPICall() {
  //   try {
  //     this.spinner.show();
  //     this.clubServ.getRestaurantNearBy().subscribe(
  //       (res: any) => {
  //         this.restaurantListNearBy = res.output;
  //         this.spinner.hide();
  //         console.log(this.selectForm.value.check, "yyyy")
  //         if (this.selectForm.value.check === "" || this.selectForm.value.check == undefined) {
  //           this.disableRestaurantsNext = true
  //         } else {
  //           this.disableRestaurantsNext = false
  //         }

  //       },
  //       (err: any) => {
  //         // this.toast.error("Error on fetching events.");
  //         this.spinner.hide();
  //       }
  //     )
  //   }
  //   catch (e) { }
  // }

  closeSelectResto(){
    this.closeSelectRestaurantPopup.emit();
  }

  // getRestaurantDetailsAPICall(id: any) {
  //   try {
  //     this.clubServ.getRestaurantDetails(id).subscribe(
  //       (res: any) => {
  //         this.restaurantListByUser = res.output;
  //         this.openModal(this.viewdetails);
  //         // this.spinner.hide();
  //       },
  //       (err: any) => {
  //         // this.toast.error("Error on fetching restaurant.");
  //         this.spinner.hide();
  //       }
  //     )
  //   }
  //   catch (e) { }
  // }

}
